import img1 from '../../assets/caseStudy/BookKeeping.jpeg';
import img2 from '../../assets/caseStudy/InternalAudit.png';
import img3 from '../../assets/caseStudy/BusinessConsulting.jpeg';
import img4 from '../../assets/caseStudy/DueDeligence.png';
import img5 from '../../assets/caseStudy/Tax.png';
import img6 from '../../assets/caseStudy/Vat.png';     
import img7 from '../../assets/caseStudy/DigitalExcellence.png';  
import img8 from '../../assets/caseStudy/TransformingBusiness.png';  
import img9 from '../../assets/caseStudy/FutureReadySolutions.png';  



const fakeData = [
    {
        id: 1,
        // designation: 'Marketing, SEO',
        title: 'Accounting & Bookkeeping',
        img: img1,
        category: 'financial'
    },
    {
        id: 2,
        // designation: 'Marketing, SEO',
        title: 'Internal Audit',
        img: img2,
        category: 'human resources'
    },
    {
        id: 3,
        // designation: 'Marketing, SEO',
        title: 'Business Consulting',
        img: img3,
        category: 'start up'
    },
    {
        id: 4,
        // designation: 'Marketing, SEO',
        title: 'Due Diligence',
        img: img4,
        category: 'strategy'
    },
    {
        id: 5,
        // designation: 'Marketing, SEO',
        title: 'Corporate Tax',
        img: img5,
        category: 'financial'
    },
    {
        id: 6,
        // designation: 'Marketing, SEO',
        title: 'VAT',
        img: img6,
        category: 'human resources'
    },
    {
        id: 7,
        // designation: 'Marketing, SEO',
        title: 'Digital Excellence Delivered',
        img: img7,
        category: 'Digital Excellence'
    },
    {
        id: 8,
        // designation: 'Marketing, SEO',
        title: 'Transforming Business Digitally',
        img: img8,
        category: 'Transforming Business'
    },
    {
        id: 9,
        // designation: 'Marketing, SEO',
        title: 'Future Ready Solutions',
        img: img9,
        category: 'Future Ready'
    }
]
export default fakeData;